import { css, keyframes } from '@emotion/css';
import checkmarkSrc from '@volumental/assets/icons/CheckmarkGreen.svg';
import { type HTMLAttributes, type JSX } from 'react';

const pop = keyframes`
  0% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
`;

const containerStyle = css`
  display: inline-block;
  animation: ${pop} 1s ease forwards;
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 1;
`;

export interface CheckmarkProps extends HTMLAttributes<HTMLImageElement> {
  alt: string;
  size?: number;
  show: boolean;
}

export function Checkmark({
  alt,
  size = 50,
  style,
  show,
  ...imgProps
}: CheckmarkProps): JSX.Element | undefined {
  return show ? (
    <img
      src={checkmarkSrc}
      alt={alt}
      className={containerStyle}
      style={{ width: size, height: size, ...style }}
      {...imgProps}
    />
  ) : undefined;
}
